// AI-CONTEXT: See docs/features/impact-in-beeld-hub.md

/**
 * Impact of one product = price x the organisation-wide impact-per-euro ratio.
 * Presentation-only: the result is never stored, the meting is the single source.
 *
 * @param {number|string} price - product price in euros
 * @param {number|null} ratio - organisation impact-per-euro (from calculateImpactPerEuro)
 * @returns {number|null} the impact in euros, or null when the price is absent/0/negative
 *   or the ratio is absent/negative (UI explains "vul je kosten in" in that case)
 */
const computeProductImpact = (price, ratio) => {
  const priceNumber = Number(price)
  const ratioNumber = Number(ratio)

  if (price === '' || price === null || price === undefined) return null
  if (ratio === null || ratio === undefined) return null
  if (!Number.isFinite(priceNumber) || priceNumber <= 0) return null
  if (!Number.isFinite(ratioNumber) || ratioNumber < 0) return null

  return priceNumber * ratioNumber
}

export { computeProductImpact }
